import { SkinProduct } from '../types/productTypes'
import { getRangeDisplayName } from '../products/productDisplayUtils'
import { getColorDisplayName } from '../products/productUtils'

export function getProductDisplayNames(product: SkinProduct): { primary: string, secondary: string | null } {
  // Set primary heading and secondary heading depending on whether item has a style/colour.
  let primaryItemHeading = getRangeDisplayName(product.style) + ' ' + getColorDisplayName(product.color)
  let secondaryItemHeading = product.displayName

  // If primary item heading is empty, make the secondary item heading the primary one.
  if (primaryItemHeading.trim() === '') {
    primaryItemHeading = secondaryItemHeading
    secondaryItemHeading = product.displaySubtitle ?? ''
  }

  return {
    primary: primaryItemHeading,
    secondary: secondaryItemHeading,
  }
}